'use client';

import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslations } from '@/lib/i18n';

export default function Footer() {
  const { language } = useLanguage();
  const t = getTranslations(language)?.footer;

  return (
    <footer className="border-t border-dispatch-surface/60 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <AppLogo
            size={22}
            text="Dispatch"
            iconName="BoltIcon"
            className="text-dispatch-text font-manrope font-bold text-base tracking-tight"
          />

          <div className="flex items-center gap-1 text-dispatch-muted text-sm font-dm-sans">
            <a href="#book"     className="px-3 py-2 hover:text-dispatch-text transition-colors font-medium">{t?.book}</a>
            <span className="text-dispatch-faint">·</span>
            <a href="#track"    className="px-3 py-2 hover:text-dispatch-text transition-colors font-medium">{t?.track}</a>
            <span className="text-dispatch-faint">·</span>
            <a href="#pay"      className="px-3 py-2 hover:text-dispatch-text transition-colors font-medium">{t?.pay}</a>
            <span className="text-dispatch-faint">·</span>
            <a href="#rate"     className="px-3 py-2 hover:text-dispatch-text transition-colors font-medium">{t?.rate}</a>
            <span className="text-dispatch-faint">·</span>
            <a href="#download" className="px-3 py-2 hover:text-dispatch-text transition-colors font-medium">{t?.downloadLink}</a>
          </div>

          <div className="flex items-center gap-4">
            <a href="#" aria-label="GitHub" className="text-dispatch-faint hover:text-dispatch-cyan transition-colors">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"/>
              </svg>
            </a>
            <a href="#" aria-label="Twitter" className="text-dispatch-faint hover:text-dispatch-cyan transition-colors">
              <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-dispatch-surface/40 flex flex-col sm:flex-row justify-between items-center gap-3 text-dispatch-faint text-xs font-mono">
          <span>{t?.copyright}</span>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-dispatch-muted transition-colors">{t?.privacy}</a>
            <span>·</span>
            <a href="#" className="hover:text-dispatch-muted transition-colors">{t?.terms}</a>
            <span>·</span>
            <a href="#" className="hover:text-dispatch-muted transition-colors">{t?.support}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}